import { Outlet } from 'react-router-dom';
import { useShellAside } from '../../layout/ShellAside';
import VerificationAside from './VerificationAside';
import './VerificationLayout.scss';

/**
 * Layout route for `/verification/*`. Hangs the section aside on the shell, as
 * AffiliateLayout does. Each page reads its own endpoint — payment
 * (`/v2/get/payment-verification/`), Veriff (`/v3/get/kyc/status/`), documents
 * (`/v1/kyc-verification/status/`) and contracts (`/v3/get/contract/user-list/`)
 * — so opening one section doesn't fetch the other three.
 */
export default function VerificationLayout() {
  useShellAside(() => <VerificationAside />, []);

  return (
    <div className="pv">
      <Outlet />
    </div>
  );
}
